import React from "react"
import { Link } from "gatsby"
import projectStart from "../../assets/images/project-start1.png"
import shape from "../../assets/images/shape/circle-shape1.png"

const JobBanner = () => {
  return (
    <div className="project-start-area ptb-100">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-12">
            <div className="project-start-image">
              <img src={projectStart} alt="project" />
            </div>
          </div>

          <div className="col-lg-6 col-md-12">
            <div className="project-start-content">
              <h2>Jobs</h2>
              <p>
                Do you want to work for a leading Software House where the
                customer is always at the center of attention? Apply Now to
                secure a position at iHunar.
              </p>

              {/* <Link to="/contact " className="default-btn"> */}
              <a href="#jobform" className="default-btn">
                Apply Now
              </a>
              {/* </Link> */}
            </div>
          </div>
        </div>
      </div>

      <div className="circle-shape1">
        <img src={shape} alt="project" />
      </div>
    </div>
  )
}

export default JobBanner
